/**
 * NOTE: Use snake case with all uppercase letters to indicate a variable
 * WHY: Camel case we are using in plugins so avoid variable name conflict
*/
export const CkeditorConstants = {
  releaseNotesRDFAAttributes: {
    class: "ref",
    id: "{threadIDOfCommentThread}",
    rel: "skos:editorialNote",
    about: "{baseHrefofDoc}#{threadIDOfCommentThread}",
    resource: "http://data.wolterskluwer.com/hlrp/bibliographic-resource/{threadIDOfCommentThread}"
  },
  suggestionType: {
    FORMAT_INLINE: "formatInline",
    INSERTION: "insertion",
    DELETION: "deletion",
  },
  command: {
    ACCEPT_SUGGESTION: 'acceptSuggestion',
    DISCARD_SUGGESTION: 'discardSuggestion',
    DISCARD_ALL_SUGGESTION: 'discardAllSuggestions',
    DISCARD_SELECTED_SUGGESTIONS: 'discardSelectedSuggestions',
    ACCEPT_ALL_SUGGESTIONS: 'acceptAllSuggestions',
    REORDER_REFERENCES: 'reorderreferences',
    RENUMBER_NUMBERED_CITATIONS: 'renumbernumberedcitations',
    REORDER_UNNUMBERED_REFERENCES: 'reorderunnumberedreferences',
    DELETE_WEB_EMAIL_LINK: 'deletewebemaillink',
    DELETE_KEYWORDS_LINK: 'keyworddefinitiondelete',
    INSERT_OTHER_DOCUMENT_LINK: 'insertotherdocumentlink',
    CLICK: 'click',
    SELECT_ALL: 'selectAll',
    REORDER_KEYWORDS: 'reorderKeywords',
    KEYWORD_DEFINITION: 'keyworddefinition',
    REORDER_CITATIONS: 'renumbercitations',
    KEYWORD_UNDO_REDO: 'keywordUndoRedo',
    SAVE: 'save',
    DELETE_IN_BATCH_BY_ID: 'deleteinbatchbyid',
    UNWRAP_LINK: 'unwraplink',
    CITATIONS: 'citations',
  },
  dropdownLabels: {
    LABEL_RENUMBER_NUMBERED_CITATIONS: 'Renumber numbered citations',
    LABEL_REORDER_UNNUMBERED_REFERENCES: 'Reorder unnumbered references',
    LABEL_REORDER_KEYWORDS: 'Reorder keywords',
  },
  /**
   * Note: Values in trackchangesMarkup variables should be as per trackchanges documentation
   */
  trackchangesMarkup: {
    SUGGESTION: 'data-suggestion',
    SUGGESTION_END_AFTER: 'data-suggestion-end-after',
    SUGGESTION_END_BEFORE: 'data-suggestion-end-before',
    SUGGESTION_START_AFTER: 'data-suggestion-start-after',
    SUGGESTION_START_BEFORE: 'data-suggestion-start-before',
  },
  commentsMarkup: {
    ADD_COMMENT: 'addComment',
    UPDATE_COMMENT: 'updateComment',
    REMOVE_COMMENT: 'removeComment',
    REMOVE_COMMENT_THREAD: 'removeCommentThread'
  },
  operation: {
    UNDO: 'undo',
    REDO: 'redo',
  },
  helperAttributes: {
    DATA_CKE_TOOLTIP_TEXT: 'data-cke-tooltip-text',
    DATA_CKE_TOOLTIP_CLASS: 'data-cke-tooltip-class',
    DATA_USERTOOLTIP: 'data-usertooltip',
    SUBTEMPLATE_NAME: 'data-subtemplate-name',
    NO_ONE: 'data-noone',
    SUBTEMPLATES_ALLOW: 'data-subtemplates-allow',
    SUBTEMPLATES_RULES: 'data-subtemplates-rules',
    CONTENTEDITABLE: 'contenteditable',
    DATA_TEMPLATE: 'data-template',
    DATA_COMMENT_ID: 'data-comment-id',
    DATA_FRAGMENT: 'data-fragment',
    CITATION_COUNT: 'data-citationcount',
    PARENT_CITATION: 'data-parentcitation',
    NUMBERED_CITATION: 'numberedcitation',
    RESOURCE: 'resource',
    TYPE_OF: 'typeof',
    DATA_CURRENTFOCUSED_ELEMENT: 'data-currentfocused-element',
    DATA_IGNORE: 'data-ignore',
    DATA_UNLOCK: 'data-unlock',
    DATA_HIDEROWS: 'data-hiderows',
    DATA_SHOWROWS: 'data-showrows',
    TRACK_CHANGES_EDITING: 'TrackChangesEditing',
    LINK_HREF: 'linkHref',
    DATA_COMMENT: 'data-comment',
    RENUMBER_CITATIONS: 'renumbercitations',
    REMOVE_INSERTEDCITATION_DISCARD: 'removeInsertedCitationsOnDiscard',
    REMOVE_INSERTEDKEYWORD_DISCARD: 'removeInsertedKeywordOnDiscard',
    DATA_THREAD_ID: 'data-thread-id',
    DATA_COMMENT_THREAD_ID: 'data-comment-thread-id',
    REMOVE_KEYWORD_FROM_TRACKCHANGES: 'removeKeywordFromTrackChanges',
    REMOVE_KEYWORD_FROM_SUBTEMPLATES: 'removeKeywordFromSubtemplate',
    DISCARD_CITATION: 'discardCitation',
    DATA_CITATION_ID: 'data-citation-id',
    DATA_FIND_RESULT: 'data-find-result',
    DATA_SOURCE_ID: 'data-source-id',
    DATA_AUTHOR_ID: 'data-author-id',
    DATA_NODE_NAME: 'data-node-name',
    DATA_DESCRIPTION: 'data-description',
    DATA_CREDIT_LINE: 'data-credit-line',
    DATA_TENANT_ID: 'data-tenant-id',
    LIST: 'list'
  },
  event: {
    EXECUTE: 'execute',
    CITATIONS_DELETE_FROM_DOCUMENT: 'citationsDeleteFromDocument',
    CITATION_PANEL_REORDER: 'citationsPanelReOrder',
    COPY_KEYWORD_FROM_KEYBOARD: 'copyKeywordFromKeyboard',
    KEYDOWN: 'keydown',
    MOUSEUP: 'mouseup',
    KEYUP: 'keyup',
    DELETE_FORWARD: 'deleteContentForward',
    DELETE_CONTENT_BACK: 'deleteContentBackward',
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    SHOW_MESSAGE: 'showMessage',
    BACKWARD: 'backward',
    FORWARD: 'forward',
    PASTE: 'paste',
    PASTE_NOT_ALLOWED: 'pasteNotAllowed',
    PASTE_EXTERNAL_CONFIRMATION_REQUIRED: 'pasteExternalConfirmationRequired',
    Cut: 'cut',
    Delete: 'delete',
    COMMENT_STATUS_THREAD_ID: 'commentStatusThreadId',
    SELECTION_CHANGE: 'selectionChange',
    MEDIA_SELECTED: 'mediaselected'
  },
  htmlElement: {
    FIG_CAPTION: 'figcaption',
    INLINE_SPAN: 'inlinespan',
    SECTION: 'section',
    ASIDE: 'aside',
    HTML_ASIDE: 'htmlAside',
    HEADER: 'header',
    DIV: 'div',
    SPAN: 'span',
    PARAGRAPH: 'paragraph',
    FIGURE: 'figure',
    FIGURETAG: 'figureTag',
    VIDEO: 'video',
    INLINE_AUDIO: 'inlineaudio',
    INLINE_IMAGE: 'inlineimage',
    IMAGE: 'img',
    AUDIO: 'audio',
    TABLE: 'table',
    LIST_ITEM: 'li',
    LINK_SPAN: 'linkspan',
    HTML_SPAN: 'htmlSpan',
    KEYWORD_SPAN: 'keywordspan',
    FIGURE_CAPTIONTAG: 'figurecaptionTag',
    FIG_CAPTIONTAG: 'figcaptionTag',
    SOURCE: 'source',
    TABLE: 'table'
  },
  htmlTagNames: {
    LI: 'li',
    UL: 'ul',
    OL: 'ol',
    P: 'p',
  },
  HEADINGS: ["heading1", "heading2", "heading3", "heading4", "heading5", "heading6"],
  HEADING_TAG_NAMES: ["h1", "h2", "h3", "h4", "h5", "h6"],
  htmlAttributes: {
    ID: 'id',
    CLASS: 'class',
    HTML_ATTRIBUTES: 'htmlAttributes',
    NUMBERED_CITATION_CLASS: 'numbered-citation',
    REL: 'rel',
    PROPERTY: 'property',
    LIST_STYLE: 'listStyle',
    LIST_TYPE: 'listType',
    LIST_ITEM_ID: 'listItemId',
    ABOUT: 'about',
    TITLE: 'title',
    DISABLE_BLOCK: 'disable-block'
  },
  attributeLinkingTypes: [
    'pcicore:WebResource',
    'pcicore:BibliographicResource',
    'pcicore:MediaResource'
  ],
  attributeToRemove: ['listIndent', 'listItemId', 'listType', 'listStyle'],
  attributeLinkOtherDocument: 'pcicore:BibliographicResource',
  attributeWebLink: 'pcicore:WebResource',
  attributeMediaResource: 'pcicore:MediaResource',
  linksTo: 'pcicore:linksTo',
  /**
   * Marker used to identify content that was copied from within our own editor/site.
   * The marker is embedded into the clipboard HTML on copy so it survives across
   * different documents, browser tabs and browsers (via the OS clipboard).
   */
  pasteSourceMarker: {
    ATTRIBUTE: 'data-wk-paste-source',
    INTERNAL: 'wk-adw',
    MIME: 'application/x-wk-adw-source'
  },
  pasteSourceType: {
    INTERNAL: 'internal',
    OFFICE: 'office',
    EXTERNAL: 'external'
  },
  STATIC_LABEL: "static-labelnames",
  elementClass: {
    suggestion_marker: 'ck-suggestion-marker',
    COMMENT: 'ck-comment-marker',
    suggestion_deletion_marker: 'ck-suggestion-marker-deletion',
    suggestion_insertion_marker: 'ck-suggestion-marker-insertion',
    LIST_CLASS: 'ck-list-bogus-paragraph',
    WIDGET_SELECTED: 'ck-widget_selected',
    CK_SPAN: 'ck-span'
  },
  commentAttributes: {
    APPROVE: 'approve',
    DRAFT: 'draft',
    REJECT: 'reject',
    RESOLVE: 'resolve',
    STATUS: 'status',
    TIMESTAMP: 'timestamp',
    USERNAME: 'username',
    ATTRIBUTES: 'attributes',
    RELEASE_NOTES: 'releaseNotes'
  },
  commentLabels: {
    APPROVE: 'Approve',
    REJECT: 'Reject',
    RESOLVE: 'Resolve',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    POST: 'Post',
    POST_COMMENT: 'Post comment',
    CANCEL: 'Cancel',
    CANCEL_COMMENT: 'Cancel comment',
    EDIT: 'Edit',
    DELETE: 'Delete'
  },
  trackChangesLabels: {
    ACCEPT: 'Accept',
    DISCARD: 'Discard',
    SUGGESTION: 'Suggestion'
  },
  localStorageItem: {
    trackchangesandcommentsdata: 'trackchangesandcommentsdata',
    currentUser: 'currentUser',
    subtemplateObject: 'subtemplateObject',
    EXISTING_SUBTEMPLATES: 'existingSubtemplates',
    enableInsertBtn: 'enableInsertBtn',
    baseHrefForLinkPlugin: 'baseHrefForLinkPlugin',
    IS_LI_TAG_UP_FOR_SUB_TEMP_INSERTION: "isLiTagUpForSubTempInsertion",
    SUB_TEMPLATE_INSERTED_GUID: "subtemplateInsertedGuid",
    DATA_UNLOCK_SECTION: "dataUnlockSection",
    SUBTEMPLATE_OBJECT: 'subtemplateObject',
    SUBTEMPLATE_LIST: 'subTemplateList',
    IS_ALL_COMMENT_DELETED: 'isAllCommentDeleted',
    BASE_HREF_PATH_URL: 'baseHrefPathUrl',
    BASE_HREF_ID: 'baseHrefId',
    CURRENT_SITE_DATA: 'currentSiteData',
    BASE_HREF_FOR_KEYWORD: 'baseHrefForKeyword',
    KEYWORD_ID_SELECT_FOR_CHEVRON: 'keywordIdSelectForChevron',
    KEYWORD_DATA: 'keywordData',
    REMOVE_MARKER_OF_LINK: 'removeMarkerLink',
    RHP_CITATION_REF_CLICK: 'rhpCitationRefClicked',
    MARKED_AND_DELETED_CITATION: 'markedAndDeletedCitation',
    USER_PROFILE: 'USER_PROFILE',
    LINK_TO_FRAGMENT_AVAILABLE: 'linkToFragmentAvailable',
    AI_UMC_SECTION_ID: 'AI_UMC_SECTION_ID'
  },
  class: {
    ckButtonContainer_ckComment_ckAnnotation: 'ck-button-container ck-comment ck-annotation',
    ck_button: 'ck-button-',
    ck_button_approve: 'ck-button-approve',
    ck_button_reject: 'ck-button-reject',
    ck_status: 'ck-status',
    REF: 'ref',
    section_content: 'section-content',
    CK_COMMENT_RESOLVE: 'ck-comment-marker ck-resolved-comment',
    WK_KEYWORD_REF: 'wk-keyword-ref',
    HIGHLIGHT_KEYWORD: 'highlight-keyword-onscroll',
    CK_MEDIA_AUDIO: 'ck-media-audio',
    CK_MEDIA_VIDEO: 'ck-media-video',
    CK_MEDIA_IMAGE: 'ck-media-image',
    CK_TOOLTIP: 'ck-tooltip',
    CK_COMMENT_EDIT: 'ck-comment--edit',
    CK_SOURCE_EDITING_ENHANCED_DIALOG: 'ck-source-editing-enhanced-dialog',
    CK_TRACKCHANGES_BUTTON: 'ck-trackchanges-button'
  },
  style: {
    block: 'block',
    none: 'none'
  },
  tooltip: {
    COMMENT: 'comment',
    INSERT_CROSS_REFERENCE: 'Insert cross-references',
    FRAGMENT_TARGET_TOOLTIP: 'This text is linked with another text fragment in the document. Deleting it will lead to orphaned links in the document.',
    FRAGMENT_TARGET_TOOLTIP_CLASS: 'internalLinkWarning'
  },
  unLockValues: {
    no_one: 'NO-ONE',
    all: 'ALL'
  },
  subTemplates: 'subTemplates',
  rightClickOptions: {
    INSERT_SUBTEMPLATE: 'Insert Subtemplate',
    GO_TO_LINK_NAME: 'Go To Link',
    GO_TO_LINK_KEY: 'goToLink',
    EDIT_LINK_NAME: 'Edit Link',
    EDIT_LINK_KEY: 'editLink',
    DELETE_LINK_NAME: 'Delete Link',
    DELETE_LINK_KEY: 'deleteLink',
    REMOVE_SUBTEMPLATE: 'Remove Subtemplate',
    DELETE_KEYWORD_KEY: 'deleteKeyword',
    LINK_TO: 'Link To...',
    COPY_BULLET_LIST_NAME: 'Copy Bullet List',
    COPY_BULLET_LIST_KEY: 'copyBulletList',
    CUT_BULLET_LIST_NAME: 'Cut Bullet List',
    CUT_BULLET_LIST_KEY: 'cutBulletList',
  },
  COMMANDS: {
    CMD_TRACK_CHANGES: 'trackChanges'
  },
  PLUGINS: {
    TRACK_CHANGES: 'TrackChanges',
    TRACKCHANGE_EDITING: 'TrackChangesEditing',
    KeywordDeleteFromDocument: 'keywordDeleteFromDocument',
    RELEASE_NOTES: 'releasenotes',
    PERMISSIONS: 'Permissions',
    CONTEXTUAL_BALLOON: 'ContextualBalloon'
  },
  treeWalkerValueType: {
    Element_Start: 'elementStart',
    Element_End: 'elementEnd'
  },
  MEDIA_AND_INLINE_ELEMENTS: ['INLINEIMAGE', 'INLINEAUDIO', 'FIGURETAG', 'TABLE'],
  DATA_COMMENT_ATTRIBUTES: ['data-comment-start-before', 'data-comment-end-after', 'data-comment-start-after', 'data-comment-end-before'],
  DCTERMS_TITLE: 'dcterms:title',
  INSERT_CROSS_REF_OPTIONS: [
    {
      id: 'apacitations',
      label: 'APA citations'
    },
    {
      id: 'creditlists',
      label: 'Credit lists',
    },
    {
      id: 'footnotes',
      label: 'Footnotes',
    },
    {
      id: 'keywords',
      label: 'Keywords & definitions'
    },
    {
      id: 'numreferences',
      label: 'Numbered references',
    },
    {
      id: 'unnumreferences',
      label: 'Unnumbered references',
    }
  ],
  BLOCK_ELEMENTS: [
    'aside',
    'section',
    'div',
    'header',
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    'paragraph',
    'article',
    'htmlArticle',
    'figure'
  ],
  KEYWORD_ATTRIBUTE: {
    KEYWORD_TYPE_OF: 'skos:Concept',
    KEYWORD_MARKER: 'keytermmarker'
  },
  REMOVE: 'remove',
  INSERT: 'insert',
  CUSTOM_ELEMENT_TO_IGNORE: ['span', 'img', 'audio', 'linkspan', 'figureTag', 'figurecaptionTag', 'figcaptionTag', 'softBreak'],
  SKOS_EDITORIAL_NOTE_ATTRIBUTE: "skos:editorialNote",
  LINK_TO_FRAGMENT_ID: "linktotextwithinthisdocument",
  MINI_EDITOR: "mini-editor",
  CK_DROPDOWN_PANEL_CLASS: "ck-dropdown__panel",
  INSERT_LINK_OPTIONS: [
    {
      id: "webemaillink",
      label: "Link to web/email address"
    },
    {
      id: "linktoanotherdocument",
      label: "Link to another document/Image as PDF",
    },
    {
      id: "linktotextoutsidethisdocument",
      label: "Link to text within another document",
    },
  ],
  INSERT_LINK_FRAGMENT_OPTION: {
    id: "linktotextwithinthisdocument",
    label: "Link to text within this document",
  },
  SKOS_EDITORIAL_NOTE_ATTRIBUTE: "skos:editorialNote",
  COMMENT_PERMISSIONS: ["document:write", "comment:write", "comment:admin", "comment:modify_all"],
  CONTENT_HARMONIZATION: {
    PCICORE_HASATTACHMENT: 'pcicore:hasAttachment',
    PCICORE_MEDIARESOURCE: 'pcicore:MediaResource',
    FRBR_EMBODIMENT: 'frbr:embodiment',
    CORE_MANIFESTATION: 'http://purl.org/vocab/frbr/core#Manifestation',
    CORE_EXPRESSION: 'http://purl.org/vocab/frbr/core#Expression',
    FRBR_EXPRESSION: 'frbr:Expression',
    FRBR_MANIFESTATION: 'frbr:Manifestation',
    FRBR_PART_OF: 'frbr:partOf'
  },
  NUM_REF_POINTER_MARKUP: [
    {
      "property": "rdf:type",
      "resource": "http://onto.wolterskluwer.com/pci/core/Fragment"
    },
    {
      "property": "dcterms:type",
      "resource": "http://data.wolterskluwer.com/shared/resource/structural-fragment-type/footnote-link"
    },
    {
      "property": "frbr:partOf"
    }
  ],
  AI_COMMANDS: [
    {
      key: 'improve-writing',
      value: 'Improve writing'
    },
    {
      key: 'adjust-length',
      value: 'Adjust length'
    },
    {
      key: 'change-tone',
      value: 'Change tone'
    },
    {
      key: 'translate',
      value: 'Translate'
    }
  ],
  WK_DISABLE_USER_SELECTION: 'wk-disable-user-selection'
};
